import { SVGProps } from 'react'

export const CalendarSquare = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M19.5 4H18.5V3C18.5 2.45 18.05 2 17.5 2C16.95 2 16.5 2.45 16.5 3V4H8.5V3C8.5 2.45 8.05 2 7.5 2C6.95 2 6.5 2.45 6.5 3V4H5.5C4.39 4 3.51 4.9 3.51 6L3.5 20C3.5 21.1 4.39 22 5.5 22H19.5C20.6 22 21.5 21.1 21.5 20V6C21.5 4.9 20.6 4 19.5 4ZM18.5 20H6.5C5.95 20 5.5 19.55 5.5 19V9H19.5V19C19.5 19.55 19.05 20 18.5 20ZM8.5 11H11.5C12.05 11 12.5 11.45 12.5 12V15C12.5 15.55 12.05 16 11.5 16H8.5C7.95 16 7.5 15.55 7.5 15V12C7.5 11.45 7.95 11 8.5 11Z"
        fill="#8A8A8E"
      />
    </svg>
  )
}
